module.exports = __webpack_public_path__ + "media/scholarship_winners/amanda-ny-sw-0e24e9b6.png";